"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CL_USER_NAME_ID = 'CLTrainer';
exports.MEMORY_KEY_HEADER_NAME = 'x-conversationlearner-memory-key';
exports.BOT_CHECKSUM_HEADER_NAME = 'x-conversationlearner-bot-checksum';
/** Indicates whether END_SESSION was called on the running Session */
var SessionEndState;
(function (SessionEndState) {
    /** Session ended because END_SESSION activity has been called */
    SessionEndState["COMPLETED"] = "completed";
    /** Session ended because of timeout or new session started w/o END_SESSION activity */
    SessionEndState["OPEN"] = "open";
})(SessionEndState = exports.SessionEndState || (exports.SessionEndState = {}));
var ScoreReason;
(function (ScoreReason) {
    // Action has been masked
    ScoreReason["NotAvailable"] = "notAvailable";
    // Action can't be scored because it hasn't been trained yet
    ScoreReason["NotScorable"] = "notScorable";
    // Score has not yet been calculated
    ScoreReason["NotCalculated"] = "notCalculated";
})(ScoreReason = exports.ScoreReason || (exports.ScoreReason = {}));
//# sourceMappingURL=UI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/models/dist/UI.js
// module id = 740
// module chunks = 0